import { render, staticRenderFns } from "./teacherListPanel.vue?vue&type=template&id=dc144000&"
import script from "./teacherListPanel.vue?vue&type=script&lang=js&"
export * from "./teacherListPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports